import { useEffect, useState } from 'react';
import { Components } from '../../global.d';

import DisclosureService from '../../services/DisclosureService';

const useDisclosure = (
  tradeId?: number,
  type?: Components.Schemas.DisclosureType
) => {
  const [disclosure, setDisclosure] = useState(undefined);

  // Make disclosure API call
  useEffect(() => {
    if (disclosure === undefined) {
      DisclosureService.listDisclosures(tradeId, type)
        .then(response => {
          setDisclosure(response);
        })
        .catch(exp => {
          setDisclosure(exp);
        });
    }
  }, [disclosure, tradeId, type]);

  return disclosure as Components.Schemas.DisclosureResponse;
};

export default useDisclosure;
